module.exports = __webpack_public_path__ + "static/media/manzo_03_thumb_hover.da1e28e5.png";